import DankMemeClassifierImage from "./dankMemeClassifier.png";
import KubailsImage from "./kubails.png";
import uFincsImage from "./ufincs.png";

export {
    DankMemeClassifierImage,
    KubailsImage,
    uFincsImage
};
